import { ComponentConfigType } from '../../utils/data-parser';
import { ComponentType, type IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
  BODY_TRANSFORMER_ITEMS_TOOLTIP,
  BASIC_VALUE_RUNTIME_TEMPLATE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.Table,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'True', value: true },
              { label: 'False', value: false },
            ],
            defaultValue: true,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'data',
          label: 'Data',
          valueComponent: {
            type: 'TextArea',
            placeholder: 'e.g., {{$instances[]}}',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'dataTransformer',
          label: 'Data Transformer (JMESPath)',
          valueComponent: {
            type: 'CodeEditor',
            placeholder: 'JMESPath expression (e.g., @[?status==`active`])',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BODY_TRANSFORMER_ITEMS_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'columns',
          label: '',
          valueComponent: {
            type: 'ColumnsConfigPanel',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'rowKey',
          label: 'Row Key',
          valueComponent: {
            type: 'Input',
            defaultValue: 'id',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'rowItemName',
          label: 'Row Item Name',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., row',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Small', value: 'small' },
              { label: 'Middle', value: 'middle' },
              { label: 'Large', value: 'large' },
            ],
            defaultValue: 'middle',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'emptyText',
          label: 'Empty Text',
          valueComponent: {
            type: 'Input',
            placeholder: 'Text to show when table is empty',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'enableColumnConfig',
          label: 'Enable Column Config',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'enableColumnMenu',
          label: 'Enable Column Menu',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'rowClassName',
          label: 'Row Class Name',
          valueComponent: {
            type: 'Input',
            placeholder: 'CSS class name for rows',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'navigateOnRowClick',
          label: 'Navigate on row click',
          valueComponent: {
            type: 'TextArea',
            placeholder:
              'e.g., test/{% $row.id %}/view or users/{% $row.name %}',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_VALUE_RUNTIME_TEMPLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'loading',
          label: 'Loading',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'prefix',
          label: 'Query Param Prefix',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., users',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value:
                "Use when there are multiple paginated tables/lists on the same page, so their page/size/sort_name/sort_order URL params don't collide.",
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'onQueryChange',
          label: 'On Query Change',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., {{ onDataQueryChange }}',
          },
          configTypes: [ComponentConfigType.Variable],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value:
                'Bind to the `on<DataName>QueryChange` callback exposed by a Loadable Data block to scope pagination/sorting to that data block instead of the page-level pagination.',
            },
          ],
        },
      ],
    },
    {
      title: 'Pagination Settings',
      items: [
        {
          name: 'pagination.show',
          label: 'Enable Pagination',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'pagination.showSizeChanger',
          label: 'Show Size Changer',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'pagination.position',
          label: 'Position',
          valueComponent: {
            type: 'Select',
            mode: 'multiple',
            options: [
              { label: 'Top Left', value: 'topLeft' },
              { label: 'Top Right', value: 'topRight' },
              { label: 'Bottom Left', value: 'bottomLeft' },
              { label: 'Bottom Right', value: 'bottomRight' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'pagination.pageSize',
          label: 'Page Size',
          valueComponent: {
            type: 'InputNumber',
            placeholder: 'Page Size',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'pagination.total',
          label: 'Total',
          valueComponent: {
            type: 'InputNumber',
            placeholder: 'Total',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Variable,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Expandable Settings',
      items: [
        {
          name: 'expandableProps.show',
          label: 'Enable Expandable',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'expandableProps.expandableSchema',
          label: 'Expanded Row Render',
          valueComponent: {
            type: 'SubSchemaEditor',
            props: {
              schemaName: 'expandableProps.expandableSchema',
              buttonText: 'Edit Expandable Schema',
            },
          },
          configTypes: [],
          tooltips: [],
        },
        {
          name: 'expandableProps.rowShow',
          label: 'Row Expandable Condition',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },

    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
